import React from "react";

const DateCellRenderer = (props: any) => {
  const value = props.value;
  if (!value) return null;
  const date = new Date(value);
  const formatted = `${String(date.getDate()).padStart(2, '0')}/${String(
    date.getMonth() + 1
  ).padStart(2, '0')}/${date.getFullYear()}`;
  return <span>{formatted}</span>;
};


export default DateCellRenderer;
